import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";

function getBasenameFromPublicUrl() {
  try {
    const pub = process.env.PUBLIC_URL || "/";
    const path = new URL(pub, window.location.origin).pathname;
    const clean = path.replace(/\/+$/, "");
    return clean || "/";
  } catch {
    return "/";
  }
}

const basename = typeof window !== "undefined" ? getBasenameFromPublicUrl() : "/";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register SW untuk PWA (AUTO reload aman saat update, tanpa reload loop)
serviceWorkerRegistration.register({
  autoReloadOnUpdate: true,   // reload otomatis hanya saat update benar2 terjadi
  autoApplyUpdate: true,      // kirim SKIP_WAITING otomatis saat update ada
  autoReloadDelayMs: 200,     // sedikit delay biar controller stabil (bisa 150-500)

  onUpdate: (reg) => {
    // Opsional: kalau mau kasih toast "Update tersedia"
    // Kalau autoApplyUpdate=true, SW akan langsung aktif lalu reload sekali.
    // Kalau kamu mau manual apply dari UI, set autoApplyUpdate:false
    // lalu panggil: serviceWorkerRegistration.skipWaiting(reg)
  },

  onSuccess: () => {
    // pertama kali SW terpasang
  },

  onControllerChange: () => {
    // event saat SW baru jadi controller (sebelum reload sekali)
  },
});

reportWebVitals();
